export function getUserDisplayName(user) {
  if (!user) return '';
  const name = typeof user === 'string' ? user : user?.name;
  if (name && String(name).trim()) return String(name).trim();
  const email = typeof user === 'object' ? user?.email : '';
  if (email && String(email).trim()) return String(email).trim();
  return '';
}

export function getUserInitials(user, { max = 2 } = {}) {
  const raw = getUserDisplayName(user);
  if (!raw) return 'U';

  const cleaned = raw
    .replace(/@.*/, '') // email local-part only
    .replace(/[^a-zA-Z0-9\s]/g, ' ')
    .trim();

  const parts = cleaned.split(/\s+/).filter(Boolean);
  if (!parts.length) return 'U';

  const first = parts[0][0] || '';
  const last = parts.length > 1 ? (parts[parts.length - 1][0] || '') : '';
  const initials = (first + last).toUpperCase();

  if (initials.length >= 2) return initials.slice(0, Math.max(1, max));
  // Single token: take first 2 chars if possible (e.g. "romeesh" -> "RO")
  return parts[0].slice(0, Math.max(1, max)).toUpperCase();
}

